import { Box, Button, SingleSelect, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { slimCardItems } from "designSystemLegacy/data";

export default () => {
	const selectActions = [
		<Button
			design="link"
			onClick={() => console.log("GoToDialog action")}
			res="GoToDialog"
		/>,
	];

	const options = [
		{ id: "0", name: "" },
		...slimCardItems,
	];
	
	options[2].invalid = true;

	return (
		<Box height={60}>
			<CssColumnGrid columns={2}>
				<Text semiBold text="without slimCardInPopupOnly" />
				<Text semiBold text="with slimCardInPopupOnly" />
				<SingleSelect
				// remove input's clear selection bubble
					disableClearable
					// show groups
					grouped
					options={options}
					// add action to drop down
					selectActions={selectActions}
					// use slim card options rendering
					slimCard
					// add SUGGESTED tag
					suggestedGroups={["CA"]}
					value={options[0]}
				/>
				<SingleSelect
				// remove input's clear selection bubble
					disableClearable
					// show groups
					grouped
					options={options}
					// add action to drop down
					selectActions={selectActions}
					// use slim card options rendering
					slimCard
					slimCardInPopupOnly
					// add SUGGESTED tag
					suggestedGroups={["CA"]}
					value={options[0]}
				/>
			</CssColumnGrid>
		</Box>
	);
};